export const educationData = [
    {
        id: 1,
        institution: 'IGNOU',
        course: 'Master of Arts in Sociology ',
        startYear: '2020',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'COLLEGE OF ENGINEERING ADOOR.',
        course: 'Bachelor of Technology (B-Tech.) in Electrical & Electronics Engineering',
        startYear: '2016',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'NSS POLYTECHNIC COLLEGE.',
        course: 'Diploma in Electrical & Electronics Engineering',
        startYear: '2013',
        endYear: '2016'
    },
]